import { api, ApiError } from "@/api/api";
import { ValidateAssetRequestData } from "@/api/validation-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useValidateMask() {
  const queryClient = useQueryClient();

  return useMutation<{}, ApiError, ValidateAssetRequestData>({
    mutationKey: ["POST", "validation", "validateMask"],
    mutationFn: api.validation.validateMask.post,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["GET", "episodes"] });
      // TODO: Invalidate only the affected episode, not all of them (need to know episode id of the image)
      queryClient.invalidateQueries({ queryKey: ["GET", "episodeDetails"] });
      queryClient.invalidateQueries({
        queryKey: ["GET", "submission", "assetsReadyForSubmission"],
      });
      queryClient.invalidateQueries({
        queryKey: ["GET", "masks", variables.id],
      });
      // TODO: Invalidate only image related to the mask, not all of them (need to know image id of the mask)
      queryClient.invalidateQueries({
        queryKey: ["GET", "images"],
      });
    },
  });
}
